import lodash from 'lodash';

export class TranslationManager {
  private static instance: TranslationManager;
  private translations: { [locale: string]: any } = {};
  private currentLocale: string;

  private constructor() {
    this.currentLocale = window.localStorage.getItem('locale') || 'en-us';
    // console.log('TranslationManager initialized with locale:', this.currentLocale);
  }

  public static getInstance(): TranslationManager {
    if (!TranslationManager.instance) {
      TranslationManager.instance = new TranslationManager();
    }
    return TranslationManager.instance;
  }

  public registerTranslations(translations: { [locale: string]: any }): void {
    // console.log('Registering translations:', translations);
    Object.entries(translations).forEach(([locale, localeTranslations]) => {
      if (!this.translations[locale]) {
        this.translations[locale] = {};
      }
      this.translations[locale] = lodash.merge(this.translations[locale], localeTranslations);
      // console.log(`Registered translations for ${locale}:`, this.translations[locale]);
    });
  }

  public setLocale(locale: string): void {
    this.currentLocale = locale;
    window.localStorage.setItem('locale', locale);
    // console.log('Locale set to:', locale);
  }

  public getLocale(): string {
    return this.currentLocale;
  }

  public translate(
    key: string,
    defaultResult: string = '',
    interpolations: { [key: string]: string } = {}
  ): string {
    // console.log('Translating key:', key, 'for locale:', this.currentLocale);
    // console.log('Available translations:', this.translations[this.currentLocale]);
    
    let result = lodash.get(this.translations[this.currentLocale], key);
    // console.log('Translation result:', result);
    
    if (result && Object.keys(interpolations).length > 0) {
      Object.entries(interpolations).forEach(([k, v]) => {
        result = result.replace(`%{${k}}`, v);
      });
    }

    return result ?? defaultResult;
  }
} 